import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { MapSubtopicOne } from "../../objects/Tema4/subtopicOne/MapSubtopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Monitor } from "../../objects/Tema4/subtopicOne/monitor";
import { Teclado } from "./teclado";
import { PanelesTecladoQuiz } from "../../objects/Tema4/subtopicOne/panelesTecladoQuiz";
import { Billetes } from "../../objects/Tema4/subtopicOne/billetes";
import { Moneda } from "../../objects/Tema4/subtopicOne/moneda";
import { PanelesBilletesQuiz } from "../../objects/Tema4/subtopicOne/panelesBilletesQuiz";
import { PinPad } from "./pinPad";
import { Tarjeta } from "../../objects/Tema4/subtopicOne/tarjeta";

export class SceneTopicFour extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.monitor = new Monitor(this.loadingManager);
		this.monitor.visible = false;
		this.add(this.monitor)

		this.teclado = new Teclado(this.loadingManager);
		this.teclado.visible = false
		this.add(this.teclado)

		this.PanelesTecladoQuiz = new PanelesTecladoQuiz(this.loadingManager);
		this.PanelesTecladoQuiz.visible = false
		this.add(this.PanelesTecladoQuiz)

		this.BilleteOne = new Billetes(this.loadingManager);
		this.BilleteOne.visible = false
		this.add(this.BilleteOne)

		this.BilleteTwo = new Billetes(this.loadingManager);
		this.BilleteTwo.visible = false
		this.add(this.BilleteTwo)

		this.BilleteThree = new Billetes(this.loadingManager);
		this.BilleteThree.visible = false
		this.add(this.BilleteThree)

		this.BilleteFour = new Billetes(this.loadingManager);
		this.BilleteFour.visible = false
		this.add(this.BilleteFour)

		this.Moneda = new Moneda(this.loadingManager);
		this.Moneda.visible = false
		this.add(this.Moneda)

		this.panelesBilletesQuiz = new PanelesBilletesQuiz(this.loadingManager);
		this.panelesBilletesQuiz.visible = false
		this.add(this.panelesBilletesQuiz)

		this.pinPad = new PinPad(this.loadingManager);
		this.pinPad.visible = false
		this.add(this.pinPad)

		this.tarjeta = new Tarjeta(this.loadingManager);
		// this.tarjeta.visible = false
		this.add(this.tarjeta)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;

					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [];
					this.activeAudio()
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 5:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;

					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [];
					this.activeAudio()
				});
				break;
			default:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.4;
				this.camera.control.maxDistance = 2;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicTwo.activityTwo.moveCameraOverKeyboard, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.4157, -0.4735, -1.8407), 1, new Vector3(-11.132, -1.237, -1.84), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 0.7;
				this.camera.control.maxDistance = 1;
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.showKeyboard, () => {
			this.teclado.position.set(-11.2224, -0.99, -1.8533)
			this.teclado.visible = true
			this.teclado.onAnimateKeysQuizOne()
			this.PanelesTecladoQuiz.visible = true
			this.PanelesTecladoQuiz.OptionA.position.set(-0.25, 0.13, 0)
			this.PanelesTecladoQuiz.OptionB.position.set(0.41, 0.08, 0)
			this.PanelesTecladoQuiz.OptionC.position.set(-0.077, -0.03, 0)
			// this.PanelesTecladoQuiz.helpersChild()
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.teclado.F1,
				this.teclado.F11,
				this.teclado.Subtotal,
			];

			this.mouseListenersActivityTwo()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.moveCameraToBillets, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.9594, -0.3951, -0.7619), 1, new Vector3(-11.21, -1.057, -0.763), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 0.8;
				this.camera.control.maxDistance = 1;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.showBillets, () => {
			this.BilleteOne.visible = true
			this.BilleteOne.rotation.set(0, 0, 0)
			this.BilleteOne.position.set(-11.25, -0.98, -1.05)
			this.BilleteOne.Billetes.name = "BilleteOne"

			this.BilleteTwo.visible = true
			this.BilleteTwo.rotation.set(0, 0, 0)
			this.BilleteTwo.position.set(-11.25, -0.98, -0.75)
			this.BilleteTwo.Billetes.name = "BilleteTwo"

			this.BilleteThree.visible = true
			this.BilleteThree.rotation.set(0, 0, 0)
			this.BilleteThree.position.set(-11.25, -0.98, -0.45)
			this.BilleteThree.Billetes.name = "BilleteThree"

			this.BilleteFour.visible = true
			this.BilleteFour.rotation.set(0, 0, 0)
			this.BilleteFour.position.set(-11.3, -0.96, -0.4)
			this.BilleteFour.Billetes.name = "BilleteFour"

			this.Moneda.visible = true
			this.Moneda.scale.set(5, 5, 5)
			this.Moneda.position.set(-11.4, -0.96, -1.11)

			this.teclado.visible = true
			this.panelesBilletesQuiz.visible = true

			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.BilleteOne,
				this.BilleteTwo,
				this.BilleteThree,
				this.BilleteFour,
				this.Moneda,
			];
			this.mouseListenersActivityThree()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.moveCameraOverKeyboard, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.4931, -0.5144, -0.7973), 1, new Vector3(-11.205, -1.261, -0.797), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 0.75;
				this.camera.control.maxDistance = 1.05;
			});
			this.teclado.position.set(-11.3, -0.99, -0.8)
			this.teclado.visible = true
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.quizOne, () => {
			this.teclado.activityFiveQuizOneAnimation()
			this.PanelesTecladoQuiz.visible = true
			this.PanelesTecladoQuiz.position.set(-11.28, -0.93, -1.07)
			this.PanelesTecladoQuiz.OptionA.position.set(0, 0.09, 0)
			this.PanelesTecladoQuiz.OptionB.position.set(0, -0.15, 0)
			this.PanelesTecladoQuiz.OptionC.position.set(0.6, 0.25, 0)
			// this.PanelesTecladoQuiz.helpersChild()
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.teclado.Mayus,
				this.teclado.Control,
				this.teclado.Borrar,
			];

			this.mouseListenersActivityFiveQuizOne()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.quizTwo, () => {
			this.teclado.activityFiveQuizTwoAnimation()
			this.PanelesTecladoQuiz.visible = true
			this.PanelesTecladoQuiz.OptionA.position.set(0.03, 0.17, 0)
			this.PanelesTecladoQuiz.OptionB.position.set(0.4, 0, 0)
			this.PanelesTecladoQuiz.OptionC.position.set(0.03, 0, 0)
			// this.PanelesTecladoQuiz.helpersChild()
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.teclado.F,
				this.teclado.F3,
				this.teclado.F1,
			];

			this.mouseListenersActivityFiveQuizTwo()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.quizThree, () => {
			this.teclado.activityFiveQuizThreeAnimation()
			this.PanelesTecladoQuiz.visible = true
			this.PanelesTecladoQuiz.OptionA.position.set(0.12, 0.25, 0)
			this.PanelesTecladoQuiz.OptionB.position.set(0.2, -0.15, 0)
			this.PanelesTecladoQuiz.OptionC.position.set(0.69, -0.05, 0)
			// this.PanelesTecladoQuiz.helpersChild()
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.teclado.T,
				this.teclado.F11,
				this.teclado.Subtotal,
			];

			this.mouseListenersActivityFiveQuizThree()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.showPinPad, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.0671, -0.2342, -0.6607), 1, new Vector3(-10.532, -0.999, -0.661), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.5;
				this.camera.control.maxDistance = 1.9;
			});
			this.teclado.position.set(-11.3, -0.99, -0.8)
			this.teclado.visible = true
			this.pinPad.position.set(-10.85, -0.97, 0.078)
			this.pinPad.visible = true
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.insertCard, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.5;
				this.camera.control.maxDistance = 1.9;
			});
			// this.tarjeta.helpersChild()
			this.tarjeta.insertCard()
			// Wait for the animations
			setTimeout(() => {
				ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.showPinPad)
			}, 3000);
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.removeCard, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.5;
				this.camera.control.maxDistance = 1.9;
			});
			// this.tarjeta.helpersChild()
			this.tarjeta.removeCard()
			// Wait for the animations
			setTimeout(() => {
				this.pinPad.visible = false
				this.teclado.visible = false
			}, 3000);
		})
	}
	mouseListenersActivityThree() {
		// This variable validate the user answer
		let selectedChange;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Option A
					case 'BilleteOne':
					case 'Moneda10':
						this.BilleteOne.onClose()
						this.Moneda.onClose()
						this.BilleteTwo.onFurther()
						this.BilleteThree.onFurther()
						this.BilleteFour.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
						selectedChange = name
						break;
					// Option B -- correct option
					case 'BilleteTwo':
						this.BilleteTwo.onClose()
						this.BilleteOne.onFurther()
						this.Moneda.onFurther()
						this.BilleteThree.onFurther()
						this.BilleteFour.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionB)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
						selectedChange = name
						break;
					// Option C
					case 'BilleteThree':
					case 'BilleteFour':
						this.BilleteThree.onClose()
						this.BilleteFour.onClose()
						this.BilleteOne.onFurther()
						this.Moneda.onFurther()
						this.BilleteTwo.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionC)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
						selectedChange = name
						break;
					default:
						break;
				}
			}
			if (selectedChange === "BilleteTwo") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.billetsQuiz, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.winBilletsQuiz)
					this.teclado.visible = false
					this.Moneda.onFurther()
					this.BilleteOne.onFurther()
					this.BilleteTwo.onFurther()
					this.BilleteThree.onFurther()
					this.BilleteFour.onFurther()
					this.Moneda.visible = false
					this.BilleteOne.visible = false
					this.BilleteTwo.visible = false
					this.BilleteThree.visible = false
					this.BilleteFour.visible = false
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
					this.panelesBilletesQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.billetsQuiz, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.failBilletsQuiz)
					this.teclado.visible = false
					this.Moneda.onFurther()
					this.BilleteOne.onFurther()
					this.BilleteTwo.onFurther()
					this.BilleteThree.onFurther()
					this.BilleteFour.onFurther()
					this.Moneda.visible = false
					this.BilleteOne.visible = false
					this.BilleteTwo.visible = false
					this.BilleteThree.visible = false
					this.BilleteFour.visible = false
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
					this.panelesBilletesQuiz.visible = false
				})
			}
		});
	}
	mouseListenersActivityTwo() {
		// This variable validate the user answer
		let selectedKey;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Tecla F1
					case 'Cube093':
						this.teclado.restartElevationQuizOne()
						this.teclado.onAnimateKeysQuizOne()
						this.teclado.clearKeyAnimation(this.teclado.F1)
						this.teclado.onElevate(this.teclado.F1)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionA)
						selectedKey = name
						break;
					// Tecla Subtotal -- correct option
					case 'Cube014':
						this.teclado.restartElevationQuizOne()
						this.teclado.onAnimateKeysQuizOne()
						this.teclado.clearKeyAnimation(this.teclado.Subtotal)
						this.teclado.onElevate(this.teclado.Subtotal)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionB)
						selectedKey = name
						break;
					// Tecla F11
					case 'Cube072':
						this.teclado.restartElevationQuizOne()
						this.teclado.onAnimateKeysQuizOne()
						this.teclado.clearKeyAnimation(this.teclado.F11)
						this.teclado.onElevate(this.teclado.F11)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionC)
						selectedKey = name
						break;
					default:
						break;
				}
			}
			if (selectedKey === "Cube014") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.keyboardQuiz, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.winKeyboardQuiz)
					this.teclado.visible = false
					this.teclado.restartElevationQuizOne()
					this.teclado.clearKeyAnimation(this.teclado.F1)
					this.teclado.clearKeyAnimation(this.teclado.F11)
					this.teclado.clearKeyAnimation(this.teclado.Subtotal)
					this.PanelesTecladoQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.keyboardQuiz, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.failKeyboardQuiz)
					this.teclado.visible = false
					this.teclado.restartElevationQuizOne()
					this.teclado.clearKeyAnimation(this.teclado.F1)
					this.teclado.clearKeyAnimation(this.teclado.F11)
					this.teclado.clearKeyAnimation(this.teclado.Subtotal)
					this.PanelesTecladoQuiz.visible = false
				})
			}
		});
	}
	mouseListenersActivityFiveQuizOne() {
		// This variable validate the user answer
		let selectedKey;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Tecla Mayus
					case 'Cube008':
						this.teclado.activityFiveQuizOneRestartElevation()
						this.teclado.activityFiveQuizOneAnimation()
						this.teclado.clearKeyAnimation(this.teclado.Mayus)
						this.teclado.onElevate(this.teclado.Mayus)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionA)
						selectedKey = name
						break;
					// Tecla Control
					case 'Cube012':
						this.teclado.activityFiveQuizOneRestartElevation()
						this.teclado.activityFiveQuizOneAnimation()
						this.teclado.clearKeyAnimation(this.teclado.Control)
						this.teclado.onElevate(this.teclado.Control)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionB)
						selectedKey = name
						break;
					// Tecla Borrar -- correct option
					case 'Cube030':
						this.teclado.activityFiveQuizOneRestartElevation()
						this.teclado.activityFiveQuizOneAnimation()
						this.teclado.clearKeyAnimation(this.teclado.Borrar)
						this.teclado.onElevate(this.teclado.Borrar)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionC)
						selectedKey = name
						break;
					default:
						break;
				}
			}
			if (selectedKey === "Cube030") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizOne, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizOne, true)
					this.teclado.visible = false
					this.teclado.activityFiveQuizOneRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.Mayus)
					this.teclado.clearKeyAnimation(this.teclado.Control)
					this.teclado.clearKeyAnimation(this.teclado.Borrar)
					this.PanelesTecladoQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizOne, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizOne, false)
					this.teclado.visible = false
					this.teclado.activityFiveQuizOneRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.Mayus)
					this.teclado.clearKeyAnimation(this.teclado.Control)
					this.teclado.clearKeyAnimation(this.teclado.Borrar)
					this.PanelesTecladoQuiz.visible = false
				})
			}
		});
	}
	mouseListenersActivityFiveQuizTwo() {
		// This variable validate the user answer
		let selectedKey;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Tecla F -- correct option
					case 'Cube088':
						this.teclado.activityFiveQuizTwoRestartElevation()
						this.teclado.activityFiveQuizTwoAnimation()
						this.teclado.clearKeyAnimation(this.teclado.F)
						this.teclado.onElevate(this.teclado.F)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionA)
						selectedKey = name
						break;
					// Tecla F3
					case 'Cube055':
						this.teclado.activityFiveQuizTwoRestartElevation()
						this.teclado.activityFiveQuizTwoAnimation()
						this.teclado.clearKeyAnimation(this.teclado.F3)
						this.teclado.onElevate(this.teclado.F3)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionB)
						selectedKey = name
						break;
					// Tecla F1
					case 'Cube093':
						this.teclado.activityFiveQuizTwoRestartElevation()
						this.teclado.activityFiveQuizTwoAnimation()
						this.teclado.clearKeyAnimation(this.teclado.F1)
						this.teclado.onElevate(this.teclado.F1)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionC)
						selectedKey = name
						break;
					default:
						break;
				}
			}
			if (selectedKey === "Cube088") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizTwo, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizTwo, true)
					this.teclado.visible = false
					this.teclado.activityFiveQuizTwoRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.F)
					this.teclado.clearKeyAnimation(this.teclado.F3)
					this.teclado.clearKeyAnimation(this.teclado.F1)
					this.PanelesTecladoQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizTwo, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizTwo, false)
					this.teclado.visible = false
					this.teclado.activityFiveQuizTwoRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.F)
					this.teclado.clearKeyAnimation(this.teclado.F3)
					this.teclado.clearKeyAnimation(this.teclado.F1)
					this.PanelesTecladoQuiz.visible = false
				})
			}
		});
	}
	mouseListenersActivityFiveQuizThree() {
		// This variable validate the user answer
		let selectedKey;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Tecla T -- correct option
					case 'Cube024':
						this.teclado.activityFiveQuizThreeRestartElevation()
						this.teclado.activityFiveQuizThreeAnimation()
						this.teclado.clearKeyAnimation(this.teclado.T)
						this.teclado.onElevate(this.teclado.T)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionA)
						selectedKey = name
						break;
					// Tecla F11
					case 'Cube072':
						this.teclado.activityFiveQuizThreeRestartElevation()
						this.teclado.activityFiveQuizThreeAnimation()
						this.teclado.clearKeyAnimation(this.teclado.F11)
						this.teclado.onElevate(this.teclado.F11)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionB)
						selectedKey = name
						break;
					// Tecla Subtotal
					case 'Cube014':
						this.teclado.activityFiveQuizThreeRestartElevation()
						this.teclado.activityFiveQuizThreeAnimation()
						this.teclado.clearKeyAnimation(this.teclado.Subtotal)
						this.teclado.onElevate(this.teclado.Subtotal)
						this.PanelesTecladoQuiz.onRotate(this.PanelesTecladoQuiz.OptionC)
						selectedKey = name
						break;
					default:
						break;
				}
			}
			if (selectedKey === "Cube024") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizThree, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizThree, true)
					this.teclado.visible = false
					this.teclado.activityFiveQuizThreeRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.T)
					this.teclado.clearKeyAnimation(this.teclado.F11)
					this.teclado.clearKeyAnimation(this.teclado.Subtotal)
					this.PanelesTecladoQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.respondQuizThree, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.validateQuizThree, false)
					this.teclado.visible = false
					this.teclado.activityFiveQuizThreeRestartElevation()
					this.teclado.clearKeyAnimation(this.teclado.T)
					this.teclado.clearKeyAnimation(this.teclado.F11)
					this.teclado.clearKeyAnimation(this.teclado.Subtotal)
					this.PanelesTecladoQuiz.visible = false
				})
			}
		});
	}
	renderAnimations(delta) {
		//animaciones
	}
}